
<template>
  <div>
    <strong class="header-title">Ensayos</strong>
    <b-row class="mt-5 mb-5">
      <b-col cols="3">
        <label for="envioPO" class="form-label">Envio PO</label>
        <b-form-datepicker size="sm" v-model="envioPO" id="envioPO"></b-form-datepicker>
      </b-col>
      <b-col cols="3">
        <label for="instruccionesCliente" class="form-label">Instrucciones envio muestra</label>
        <b-form-datepicker size="sm" v-model="instruccionesCliente" id="instruccionesCliente"></b-form-datepicker>
      </b-col>
      <b-col cols="3">
        <label for="recepcionLaboratorio" class="form-label">Recepción muestra laboratorio</label>
        <b-form-datepicker size="sm" v-model="recepcionLaboratorio" id="recepcionLaboratorio"></b-form-datepicker>
      </b-col>
      <b-col cols="3">
        <label for="planificacionEnsayo" class="form-label">Planificación Ensayo</label>
        <b-form-datepicker size="sm" v-model="planificacionEnsayo" id="planificacionEnsayo"></b-form-datepicker>
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col cols="3">
        <label for="avanceResultado" class="form-label">Avance Resultado Cliente</label>
        <b-form-datepicker size="sm" v-model="avanceResultado" id="avanceResultado"></b-form-datepicker>
      </b-col>
      <b-col cols="3">
        <label for="envioInforme" class="form-label">Envío informe Cliente</label>
        <b-form-datepicker size="sm" v-model="envioInforme" id="envioInforme"></b-form-datepicker>
      </b-col>
      <b-col cols="3">
        <label for="reunionResultados" class="form-label">Reunión Resultados</label>
        <b-form-datepicker size="sm" v-model="reunionResultados" id="reunionResultados"></b-form-datepicker>
      </b-col>
    </b-row>
    <b-row style="margin-top: 100px">
      <b-col cols="3">
        <label for="idioma" class="form-label">Idioma</label>
        <b-form-select size="sm" v-model="idioma">
          <option value=""></option>
          <option value="Inglés">Inglés</option>
          <option value="Español">Español</option>
          <option value="Otro">Otro</option>
        </b-form-select>
      </b-col>
      <b-col cols="3">
        <label for="preparacion" class="form-label">Preparación</label>
        <b-form-select size="sm" v-model="preparacion">
          <option value=""></option>
          <option value="Si">Si</option>
          <option value="No">No</option>
          <option value="-">-</option>
        </b-form-select>
      </b-col>
      <b-col cols="3">
        <label for="tipoEnsayo" class="form-label">Tipo Ensayo</label>
        <b-form-select size="sm" v-model="tipoEnsayo">
          <option value=""></option>
          <option value="IEH">IEH</option>
          <option value="CRH">CRH</option>
          <option value="RTL">RTL</option>
          <option value="Otro">Otros</option>
        </b-form-select>
      </b-col>
      <b-col cols="3">
        <label for="informe" class="form-label">Informe</label>
        <b-form-select size="sm" v-model="informe">
          <option value=""></option>
          <option value="unico">Único</option>
          <option value="varios">Varios</option>
          <option value="-">-</option>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row class="mt-5 mb-3">
      <b-col>
        <label for="notas" class="form-label">Notas</label>
        <b-form-textarea class="form-control" size="sm" v-model="notas" id="notas" rows="5" no-resize />
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.header-title { font-size: 150%; }
</style>

<script>
export default {
  name: 'Ensayos',
  props: {
    importeItem: { type: Number, required: true },
  },
  data() {
    return {
      id: '',
      ensayo: '',
      instruccionesCliente: '',
      envioPO: '',
      recepcionLaboratorio: '',
      planificacionEnsayo: '',
      avanceResultado: '',
      envioInforme: '',
      idioma: '',
      tipoEnsayo: '',
      preparacion: '',
      informe: '',
      reunionResultados: '',
      notas: '',
      edit: false,
    };
  },
  methods: {
    loadItemEnsayo(datos) {
      if (!datos) return;
      this.id = datos.id || '';
      this.instruccionesCliente = datos.instruccionesCliente || '';
      this.envioPO = datos.envioPO || '';
      this.recepcionLaboratorio = datos.recepcionLaboratorio || '';
      this.planificacionEnsayo = datos.planificacionEnsayo || '';
      this.avanceResultado = datos.avanceResultado || '';
      this.envioInforme = datos.envioInforme || '';
      this.idioma = datos.idioma || '';
      this.tipoEnsayo = datos.tipoEnsayo || '';
      this.preparacion = datos.preparacion || '';
      this.informe = datos.informe || '';
      this.reunionResultados = datos.reunionResultados || '';
      this.notas = datos.notas || '';
      this.edit = true;
    },

    // ⛑️ CAMBIO CLAVE: devolver undefined (no null) cuando está vacío,
    // para que el padre pueda OMITIR la propiedad 'ensayo' en el payload.
    cargarEnsayo() {
      const datosEnsayo = {
        instruccionesCliente: this.instruccionesCliente,
        envioPO: this.envioPO,
        recepcionLaboratorio: this.recepcionLaboratorio,
        planificacionEnsayo: this.planificacionEnsayo,
        avanceResultado: this.avanceResultado,
        envioInforme: this.envioInforme,
        idioma: this.idioma,
        tipoEnsayo: this.tipoEnsayo,
        preparacion: this.preparacion,
        informe: this.informe,
        reunionResultados: this.reunionResultados,
        notas: this.notas,
      };

      const tieneDatos = Object.values(datosEnsayo).some(v => v && `${v}`.trim() !== '');

      // si estamos editando y hay id, lo incluimos aunque no haya cambios para conservar.
      if (this.edit && this.id) datosEnsayo.id = this.id;

      // ✅ devolvemos undefined si NO hay datos => el padre no enviará 'ensayo'
      return (tieneDatos || (this.edit && this.id)) ? datosEnsayo : undefined;
    },

    resetEnsayos() {
      this.id = '';
      this.instruccionesCliente = '';
      this.envioPO = '';
      this.recepcionLaboratorio = '';
      this.planificacionEnsayo = '';
      this.avanceResultado = '';
      this.envioInforme = '';
      this.idioma = '';
      this.tipoEnsayo = '';
      this.preparacion = '';
      this.informe = '';
      this.reunionResultados = '';
      this.notas = '';
      this.edit = false;
    },
  },
};
</script>

<style>
.custom-checkbox { width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; border: 1px solid #ccc; }
</style>

